import { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Snackbar
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from '../../../Api';
import Iconify from '../../../components/Iconify';
import { useTranslation } from 'react-i18next';

export default function ResetUserPassword({ handleClose, user }) {
  const { t } = useTranslation();
  const [values, setValues] = useState({
    password: '',
    confirm: ''
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [alert, setalert] = useState({ visible: true, message: '' });
  const [issubmiting, setissubmiting] = useState(false);

  const resetFunction = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('user_id', user?.id);
    formdata.append('new_password', values.password);
    formdata.append('new_password_confirmation', values.confirm);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.change_password_by_admin, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);

        if (status === 200 || status === 201) {
          setalert({ visible: true, message: result.message });
          setShowSnackbar(true);
          // handleClose();
        } else {
          setalert({ visible: true, message: result.error });
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          handleClose();
        }}
      >
        <Alert
          onClose={() => {
            setShowSnackbar(false);
          }}
          severity="success"
        >
          {alert.message}
        </Alert>
      </Snackbar>
      <Box px={4} pt={6} pb={2}>
        <form>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography variant="h4" gutterBottom>
              {t('ChangePassword.name')}
            </Typography>
          </Box>

          <TextField
            fullWidth
            label={t('ChangePassword.new')}
            margin="normal"
            name="password"
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            value={values.password}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <TextField
            fullWidth
            label={t('ChangePassword.confirm')}
            margin="normal"
            name="confirm"
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            value={values.confirm}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          {alert && !alert.message.includes('success') && alert.message != '' && (
            <Alert style={{ marginTop: 10 }} severity="error">
              {alert.message}
            </Alert>
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              py: 2
            }}
          >
            <LoadingButton
              sx={{
                marginRight: 1
              }}
              onClick={resetFunction}
              color="primary"
              variant="contained"
              loading={issubmiting}
            >
              {t('ChangePassword.buttons.0')}
            </LoadingButton>

            <Button onClick={handleClose} variant="outlined">
              {t('ChangePassword.buttons.1')}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
}
